// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on.
import { createFileRoute } from '@tanstack/react-router'
import { SignInScreen } from '../features/auth/SignInScreen'
import { text } from '../shared/routing/search'

export const Route = createFileRoute('/sign-in')({
  staticData: { screenId: 'AuthSignInScreen', access: 'signed out' },
  // The route key's query arguments (screens.json `args`), as the apps' LinkResolver reads them;
  // unknown keys are dropped.
  validateSearch: (search: Record<string, unknown>): { email?: string; next?: string; reason?: string } => ({
    email: text(search.email),
    // `?next=` is the route key's returnTo (spec 08 § 3); `?returnTo=` from links sent before it still works.
    next: text(search.next) ?? text(search.returnTo),
    /** Why the session ended (the 401's reason), when it did (D193). */
    reason: text(search.reason),
  }),
  component: AuthSignInScreen,
})

function AuthSignInScreen() {
  const { email, next, reason } = Route.useSearch()
  return <SignInScreen email={email} returnTo={next} reason={reason} />
}
